


















import Vue from 'vue'
import { PageData } from 'HealthAdvisorBackendApp'
import NavbarHeader from '@/components/shared/NavbarHeader/index.vue'
import { apiFetcher } from '@/utils/api/fetcher'
import ArticleBody from '@/components/shared/ArticleBody/index.vue'

export default Vue.extend({
  name: 'AboutUs',
  components: {
    NavbarHeader,
    ArticleBody
  },
  async asyncData({ $axios, params, error }) {
    const fetchedData = await apiFetcher<PageData>({
      $axios,
      error,
      apiUrl: `/page/${params.slug}/`
    })
    const { responseData, head, schemaJsonLD } = fetchedData
    return {
      title: responseData.post_title || '',
      content: responseData.post_content || '',
      head,
      schemaJsonLD
    }
  },
  jsonld() {
    return this.$data.schemaJsonLD || null
  },
  head() {
    return this.$data.head
      ? {
          ...this.$data.head
        }
      : {}
  }
})
